import clsx from 'clsx';
import './style/index.scss';

const SheetLoader = ({ className = '' }) => (
  <div className={clsx('sheet-loading-bar', className)} />
);

export default SheetLoader;
